import styled from "styled-components";

export const CollectionContainer = styled.div`
  width: 80%;
  margin: auto;
  border-radius: 1rem;
  height: auto;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Heading = styled.h1`
  font-size: 28px;
  margin-left: 0.1rem;
  font-family: Poppins;
  padding-left: 0.2rem;
  color: #ecf0f1;
`;
export const StyledHeading = styled(Heading)`
  margin-top: 5rem;
  text-align: center;
  position: relative;
`;
export const CardContainer = styled.div`
  display: flex;
  min-height: 70vh;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Card = styled.div`
  min-height: 34.1vh;
  position: relative;
  margin-right: 1rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  // background: #bdc3c7;
  background: #fff;
  width: 15rem;
  border-radius: 1rem;
  box-shadow: 0px 1px 6px #00000029;
  // &:hover {
  //   box-shadow: 0 0 11px #fff;
  // }
`;
export const ImageContainer = styled.div`
  min-height: 28vh;
  background: #95a5a6;
  max-height: 29vh !important;
  width: 100%;
  border-radius: 1rem;
  img {
    height: 100%;
    object-fit: cover;
    border-radius: 1rem 1rem 0rem 0rem;
    width: 100%;
    &:hover {
      opacity: 1;
    }
  }
`;

export const RankTitle = styled.div`
  background: #3772ff;
  position: absolute;
  top: 0.4rem;
  left: 0.4rem;
  border-radius: 1rem;
  padding: 0.2rem 0.6rem;
  z-index: 100;
  min-height: auto;
  span {
    text-align: left;
    font-family: Poppins;
    font-weight: bold;
    color: #ecf0f1;
  }
`;

export const DetailsContainer = styled.div`
  padding: 0.25rem 0.4rem;
  border-radius: 0rem 0rem 0.3rem 0.3rem;
  font-family: Poppins;
  span {
    color: ecf0f1;
  }
`;

export const Pagination = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Button = styled.button`
  background: #393939;
  cursor: pointer;
  height: auto;
  padding: 0.6rem 1.4rem;
  color: #fff;
  font-size: 1rem;
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  font-family: Poppins;
  font-weight: 500;
  border: none;
  border-radius: 1.4rem;
`;

export const CollectionData = styled.div`
  background: #f7f7f7;
  padding: 0.7rem 1rem;
  border-radius: 1rem;
`;
